import styled from 'styled-components'
import { useQueryClient } from 'react-query'
import { Typography } from 'common/typography'
import { useRouter } from 'next/router'
import InputField from 'common/input-field'
import { SecondaryButton } from 'common/button'
import { useCompleteAccount } from 'mutations/profile'
import { useCreateCertificate } from 'mutations/certificates'
import useSession from 'querys/session'
import { useCertificate } from 'querys/certificates'
import { CircularProgress } from '@material-ui/core'

const CertificateFormStyled = styled.div`
  margin-block-start: 40px;
  margin-block-end: 40px;
  position: relative;
  .loading {
    position: absolute;
    top: 0;
    right: 0;
    color: var(--turquoise);
  }
  .inputs {
    display: grid;
    gap: 16px;
    grid-template-columns: 1fr;
    margin: 16px 0;
  }
  @media(min-width: 1024px) {
    margin-block-start: 48px;
    .inputs {
      grid-template-columns: 1fr 1fr;
    }
  }
`

function CertificateForm({ firstName, lastName }) {
  const { data: { certificate_pdf } } = useCertificate()
  const { token } = useSession()
  const { query: { certificate_uuid: uuid } } = useRouter()
  const queryClient = useQueryClient()
  const profileMutation = useCompleteAccount()
  const certificateMutation = useCreateCertificate()

  const createCertificate = (e) => {
    const payload = new FormData(e.target)
    profileMutation.mutate(payload, {
      onSuccess: () => {
        certificateMutation.mutate(null, {
          onSuccess: (data) => {
            queryClient.setQueryData(
              ['CERTIFICATE', uuid, token],
              (oldData) => ({ ...oldData, ...data }),
            )
          },
        })
      },
    })
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    createCertificate(e)
  }
  const hadleKeyPress = (e) => {
    if (e.which === 13) {
      e.preventDefault()
      createCertificate(e)
    }
  }

  if (certificateMutation.isSuccess || certificate_pdf) return null

  return (
    <CertificateFormStyled>
      {profileMutation.isLoading || certificateMutation.isLoading ? (
        <div className="loading">
          <CircularProgress size={24} color="inherit" />
        </div>
      ) : null}
      <Typography font="headline6" as="h2">Descargar certificado</Typography>
      <Typography font="regular">
        Para descargar el certificado como PDF es necesario verificar tu nombre y apellido.
        {' '}
        <b>(Este proceso solo podrá  realizarse una vez.)</b>
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className="inputs">
          <InputField
            label="Nombre"
            onChange={firstName.onChange}
            type="text"
            value={firstName.value}
            name="first_name"
            dataCy="confirm-name"
            placeholder="Jaume"
          />
          <InputField
            label="Apellido"
            onChange={lastName.onChange}
            type="text"
            onKeyPress={hadleKeyPress}
            value={lastName.value}
            name="last_name"
            dataCy="confirm-last-name"
            placeholder="Laoz"
          />
        </div>
        <SecondaryButton fullWidth fitContent responsive>Aceptar</SecondaryButton>
      </form>
    </CertificateFormStyled>
  )
}

export default CertificateForm
